import { render } from "./CustomerDetailSettingsTab.vue?vue&type=template&id=293dc6d5&scoped=true"
import script from "./CustomerDetailSettingsTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailSettingsTab.vue?vue&type=script&lang=js"

import "./CustomerDetailSettingsTab.vue?vue&type=style&index=0&id=293dc6d5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293dc6d5"]])

export default __exports__